"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.gifPaginator = exports.GiphyFetch = void 0;
var js_util_1 = require("@giphy/js-util");
var api_1 = require("./api");
Object.defineProperty(exports, "GiphyFetch", { enumerable: true, get: function () { return __importDefault(api_1).default; } });
__exportStar(require("./option-types"), exports);
__exportStar(require("./result-types"), exports);
var paginator_1 = require("./paginator");
Object.defineProperty(exports, "gifPaginator", { enumerable: true, get: function () { return paginator_1.gifPaginator; } });
var version = require('../package.json').version;
// since we have multiple SDKs, we're defining a hieracrchy
// Fetch API is lowest
if (!((_a = js_util_1.getGiphySDKRequestHeaders()) === null || _a === void 0 ? void 0 : _a.get("X-GIPHY-SDK-NAME"))) {
    // send headers with library type and version
    js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-NAME", 'FetchAPI');
    js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-VERSION", version);
}
//# sourceMappingURL=index.js.map